<template>
  <div>
    <!-- COMPONENTE QUE GERA O LOADING EFECT -->
    <v-overlay :value="overlay || $store.state.loading_pdf">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- FIM COMPONENTE QUE GERA O LOADING EFECT -->

    <!--==== CONTAINER PAGAMENTOS ====-->
    <div class="flex flex-col" v-if="emolumentosFiltrados.length">
      <div class="flex-1 bg-white shadow-xl">
        <!--====== COMBOBOX PARA FAZER O FILTRO DAS INFORMAÇÕES =======-->
        <div class="header-table" v-if="emolumentosFiltrados.length">
          <div class="combo_box_container">
            <v-combobox
              v-model="anoLectivoSelected"
              :items="opcoesAnoLectivos"
              hide-selected
              filled
              item-text="anolectivo"
              item-value="anolectivo"
              small-chips
              @change="selecionarEmolumentos()"
            ></v-combobox>
            <v-combobox
              v-model="emolumentosUnicosSelected"
              :items="emolumentosUnicos"
              hide-selected
              filled
              item-text="descricao"
              item-value="descricao"
              small-chips
              @change="selecionarEmolumentos()"
            ></v-combobox>
          </div>
          <v-btn
            v-if="showImprimir"
            small
            fab
            color="primary"
            @click="gerarHTML()"
            ><v-icon>print</v-icon></v-btn
          >
        </div>
        <!--====== FIM COMBOBOX PARA FAZER O FILTRO DAS INFORMAÇÕES =======-->

        <!-- ===== INÍCIO DA TABELA ==== -->
        <div class="main_table_container">
          <table class="table-full">
            <thead class="bg-gray100">
              <tr>
                <th class="table_head">#</th>
                <th class="table_head">Emol.</th>
                <th class="table_head">Ref.</th>
                <th class="table_head">Qtd</th>
                <th class="table_head">P. Uni.</th>
                <th class="table_head">Desc.</th>
                <th class="table_head">Multa</th>
                <th class="table_head">Pago</th>
                <th class="table_head">Data</th>
                <th class="table_head">Factura</th>
                <th class="table_head">Autor</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(emolumento, index) in emolumentosFiltrados"
                :key="index"
              >
                <td class="table_data">{{ ++index }}</td>
                <td class="table_data">
                  <span class="color-table-data">{{
                    emolumento.emolumento
                  }}</span>
                </td>
                <td class="table_data">
                  <span>{{
                    utilitarios.getMonthDescription(emolumento.fkMes)
                  }}</span>
                </td>
                <td class="table_data">
                  <span>{{ emolumento.qtd }}</span>
                </td>
                <td class="table_data">
                  <span>{{
                    utilitarios.IntegerToMoneyValueFatura(emolumento.preco)
                  }}</span>
                </td>
                <td class="table_data">
                  <span>{{
                    utilitarios.IntegerToMoneyValueFatura(emolumento.desconto)
                  }}</span>
                </td>
                <td class="table_data">
                  <span>{{
                    utilitarios.IntegerToMoneyValueFatura(emolumento.multa)
                  }}</span>
                </td>
                <td class="table_data">
                  <span>{{
                    utilitarios.IntegerToMoneyValueFatura(emolumento.pago)
                  }}</span>
                </td>
                <td class="table_data">
                  <span>{{ formatarData(emolumento.data_compra) }}</span>
                </td>
                <td class="table_data">
                  <span>{{ emolumento.numeroDocumento }}</span>
                </td>
                <td class="table_data">
                  <span>{{ emolumento.nomeUsuario }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ===== FIM DA TABELA ==== -->

        <!--==== CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->
        <div class="totaisContainer" v-if="emolumentosFiltrados.length">
          <div>
            <span class="align-totais">Total Pago</span>
            <span class="text-bold totais-font-size">
              {{
                utilitarios.IntegerToMoneyValueFatura(totaisObject.total)
              }}</span
            >
          </div>
          <div>
            <span class="align-totais">Total de descontos:</span>
            <span class="text-bold totais-font-size">
              {{
                utilitarios.IntegerToMoneyValueFatura(totaisObject.desconto)
              }}</span
            >
          </div>
          <div>
            <span class="align-totais">Total de multas:</span>
            <span class="text-bold totais-font-size">
              {{
                utilitarios.IntegerToMoneyValueFatura(totaisObject.multa)
              }}</span
            >
          </div>
        </div>
        <!--====  FIM CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->
      </div>
    </div>

    <div v-if="!emolumentosFiltrados.length">
      <p class="semPagamentos">Pagamentos não encontrado!</p>
    </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
import Swal from 'sweetalert2'
import utilitarios from '../../plugins/utilitarios'
import impressaoService from '../../services/impressaoService';
const ls = require('local-storage')
export default {
    name: 'ConsultarPagamento',
    props: {
        estudante: null,
    },
    data: () => ({
        overlay: false,
        utilitarios: utilitarios,
        desserts: [],
        opcoesAnoLectivos: [],
        anoLectivoSelected: null,
        emolumentosFiltrados: [],
        config: null,
        baseUrl: '',
        templateFull: null,
        showImprimir: true,
        emolumentosUnicos: [
            {id: 0, descricao: 'Todos'}
        ],
        emolumentosUnicosSelected:  {id: 0, descricao: 'Todos'}
    }),

    computed: {
        licencaExpirada() {
            return ls.get('licencaExpirada')
        },

        anoLectivoActual() {
            return ls.get('anolectivo')
        },

        totaisObject() {
            let totais = { multa: 0, desconto: 0, total: 0 }
            this.emolumentosFiltrados.forEach(element => {
                let multa = isNaN(element.multa) || !element.multa ? 0 : utilitarios.MoneyValueToInteger(element.multa);
                let desconto = isNaN(element.desconto) || !element.desconto ? 0 : utilitarios.MoneyValueToInteger(element.desconto);
                let preco = isNaN(element.pago) || !element.pago ? 0 : utilitarios.MoneyValueToInteger(element.pago);

                totais.multa += multa;
                totais.desconto += desconto;
                totais.total += (preco + multa - desconto);
            });
            return totais
        },
    },

    async created() {
        await this.PesquisarStatusPagamento(this.estudante)
        this.config = ls.get('configuracaoinstituicao');
        this.getUrlImpressao();
        this.getTemplateRelatorio();
    },

    methods: {
        async getUrlImpressao() {
            this.overlay = true;
            try {
                this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
            } catch (error) {
                Swal.fire('Error', 'Ocorreu um erro processando o servidor de impreção', 'error');
            } finally {
                this.overlay = false;
            }
        },

        async getTemplateRelatorio() {
            try {
                this.overlay = true;
                this.templateFull = await axios.get('/obterRelatorioByDescricao/cp').then((res) => res.data[0]);

                if (!this.templateFull) {
                    this.showImprimir = false
                }
            } catch (error) {
                utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante o carregamento do pdf do relatório!');
            } finally {
                this.overlay = false;
            }
        },

        async PesquisarStatusPagamento(estudante) {
            this.overlay = true;
            try {
                let params = { numero_matricula: estudante.numero_matricula };
                let result = await axios.post('/ObterEmolumentosPagos-est', params).then(res => res.data);

                if (result.length > 0) {
                    let listaEmolumentos = new Set();
                    result.forEach(item => {
                        listaEmolumentos.add(item.emolumento);
                    });

                    let novosEmolumentos = Array.from(listaEmolumentos).map((descricao, index) => ({ id: index + 1, descricao }));
                    this.emolumentosUnicos.push(...novosEmolumentos);
                    this.desserts = result;
                    this.listarAnoLectivosFiltro(estudante);
                }
            } catch (error) {
                Swal.fire('Erro', 'Ocorreu um erro durante o carregamento dos pagamentos!', 'error');
            } finally {
                this.overlay = false
            }
        },

        async listarAnoLectivosFiltro(estudante) {
            try {
                let params = { numero_matricula: estudante.numero_matricula };
                let result = await axios.post('/ObterAnoLectivosFiltro', params).then(res => res.data);
                if (result.length) {
                    this.opcoesAnoLectivos = result;
                    this.anoLectivoSelected = this.opcoesAnoLectivos[0]
                    // if (this.anoLectivoActual) {
                    //    // let arrayTemporario = result.filter((a) => a.anolectivo == this.anoLectivoActual);
                    //     this.anoLectivoSelected = arrayTemporario[0];
                    // } else {
                    //     this.anoLectivoSelected = result[result.length - 1];
                    // }

                    this.selecionarEmolumentos();
                }
            } catch (error) {
                Swal.fire('Erro', 'Ocorreu um erro durante o carregamento dos anos lectivos!', 'error');
            }
        },

        selecionarEmolumentos() {
            this.overlay = true;
            try {
                if (this.emolumentosUnicosSelected.descricao == 'Todos') {
                    this.emolumentosFiltrados = this.desserts.filter((e) => e.anolectivo == this.anoLectivoSelected.anolectivo);
                } else {
                    this.emolumentosFiltrados = this.desserts.filter((e) => e.anolectivo == this.anoLectivoSelected.anolectivo && e.emolumento == this.emolumentosUnicosSelected.descricao);
                }
                
            } catch (error) {
                Swal.fire('Erro', 'Erro ao ,filtrar a lista!', 'error');
            } finally {
                this.overlay = false;
            }
        },

        // Os dados vêm originalmento no formato "2022-11-21T10:25:40.000Z"
        // Método responsavél por converter no formato "2022-11-21"
        formatarData(data) {
            if (data) {
                let newData = data.split('T');
                return newData[0];
            }
        },

        // Método responsavel por criar um HTML com os dados da coleção this.dados[]
        async gerarHTML() {
            if (this.licencaExpirada) {
                Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info');
            } else {
                try {
                    this.$store.state.loading_pdf = true;

                    let template = this.templateFull.documento;
                    let relatorioDados = '';
                    let c = 1;

                    this.emolumentosFiltrados.forEach(element => {
                        let interacao1 = this.templateFull.documentoiteracao1;
                        interacao1 = interacao1.replace('{{index}}', c++);
                        interacao1 = interacao1.replace('{{elemento}}', element.emolumento);
                        interacao1 = interacao1.replace('{{mes}}', this.utilitarios.getMonthDescription(element.fkMes));
                        interacao1 = interacao1.replace('{{qtd}}', (element.qtd == null || element.qtd == 'null' || !element.qtd) ? 1 : element.qtd);
                        interacao1 = interacao1.replace('{{preco}}', this.utilitarios.IntegerToMoneyValueFatura(element.preco));
                        interacao1 = interacao1.replace('{{desconto}}', this.utilitarios.IntegerToMoneyValueFatura(element.desconto));
                        interacao1 = interacao1.replace('{{multa}}', this.utilitarios.IntegerToMoneyValueFatura(element.multa));
                        interacao1 = interacao1.replace('{{pago}}', this.utilitarios.IntegerToMoneyValueFatura(element.pago));
                        interacao1 = interacao1.replace('{{data}}', this.formatarData(element.data_compra));
                        interacao1 = interacao1.replace('{{documento}}', element.numeroDocumento);
                        interacao1 = interacao1.replace('{{atendente}}', element.nomeUsuario);
                        relatorioDados += interacao1;
                    })


                    let dadoss = {
                        '{{logoInstituicao}}': this.config.logo,
                        '{{nomeInstituicao}}': this.config.nome,
                        '{{nome}}': this.estudante.nome,
                        '{{matricula}}': this.estudante.numero_matricula,
                        '{{curso}}': this.estudante.descricao,
                        '{{classe}}': this.getClasse(this.estudante.classe_descricao),
                        '{{author}}': ls.get('nomeUsuario'),
                        '{{dataEmissao}}': this.data_hora(),
                        '{{dados}}': relatorioDados,
                        '{{totalPago}}': this.utilitarios.IntegerToMoneyValueFatura(this.totaisObject.total),
                        '{{totalMulta}}': this.utilitarios.IntegerToMoneyValueFatura(this.totaisObject.multa),
                        '{{totalDesconto}}': this.utilitarios.IntegerToMoneyValueFatura(this.totaisObject.desconto)
                    }

                    const expressaoRegular = new RegExp(Object.keys(dadoss).join("|"), "g");
                    template = template.replace(expressaoRegular, (match) => dadoss[match]);


                    let options = {
                        'format': 'A4',
                        'border': { 'right': '4mm', 'left': '4mm' },
                        'header': { 'height': '10mm' },
                        'footer': { 'height': '1mm' }
                    }

                    impressaoService.htmlToPdf(template, options);
                } catch (error) {
                    this.$store.state.loading_pdf = false;
                    Swal.fire('Erro', 'Ocorreu um erro durante a impressão', 'error');
                }

            }
        },

        // Método responsavél por guardar a data atual
        data_hora() {
            let data = new Date()
            return data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear()) + ' ' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
        },

        getClasse(classe) {
            switch (classe) {
                case 1:
                    return '10ª'
                case 2:
                    return '11ª'
                case 3:
                    return '12ª'
                case 4:
                    return '13ª'
            }
        },
    }
};
</script>

<style scoped>
.combo_box_container {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  width: 300px;
}

.header-table {
  display: flex;
  justify-content: space-between;
  padding: 5px 50px 5px 5px;
}

.semPagamentos {
  font-weight: bold;
  text-align: center;
  height: 150px;
  line-height: 150px;
}
</style>
